import React from "react";

function Contact(){
    return(
        <>
        <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Contact Us</h1>
                    </div>
                </div>
            </div>
        </section>
        <section className="contact-main pt-6 pb-60">
            <div className="container">
                <div className="contact-info-main mt-0">
                    <div className="row">
                        <div className="col-lg-10 col-offset-lg-1 mx-auto">
                            <div className="contact-info bg-white">
                                <div className="contact-info-content row mb-1">
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <div className="info-item bg-lgrey px-4 py-5 border-all text-center rounded">
                                            <div className="info-icon mb-2">
                                                <i className="fa fa-map-marker-alt theme"></i>
                                            </div>
                                            <div className="info-content">
                                                <h3>Office Location</h3>
                                                <p className="m-0">445 Mount Eden Road, Mt Eden Basundhara Chakrapath</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <div className="info-item bg-lgrey px-4 py-5 border-all text-center rounded">
                                            <div className="info-icon mb-2">
                                                <i className="fa fa-phone theme"></i>
                                            </div>
                                            <div className="info-content">
                                                <h3>Phone Number</h3>
                                                <p className="m-0">977-444-666-888</p>
                                                <p className="m-0">977-444-222-000</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 mb-4">
                                        <div className="info-item bg-lgrey px-4 py-5 border-all text-center rounded">
                                            <div className="info-icon mb-2">
                                                <i className="fa fa-envelope theme"></i>
                                            </div>
                                            <div className="info-content ps-4">
                                                <h3>Email Address</h3>
                                                <p className="m-0">info@realshield.com</p>
                                                <p className="m-0">help@realshield.com</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="contact-form1" className="contact-form">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="map rounded overflow-hiddenb rounded mb-md-4">
                                                
                                                <iframe height="400" src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=+(mangal%20bazar)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                                                
                                            </div>
                                        </div>
                                        <div className="col-lg-6">

                                            <form method="post" action="#" name="contactform2" id="contactform2">
                                                <div className="form-group mb-2">
                                                    <input type="text" name="first_name" className="form-control" id="fullname" placeholder="First Name" />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <input type="text" name="last_name" className="form-control" id="llastname" placeholder="Last Name" />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <input type="email" name="email"  className="form-control" id="email" placeholder="Email" />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <input type="text" name="phone" className="form-control" id="phnumber" placeholder="Phone" />
                                                </div>
                                                <div className="textarea mb-2">
                                                    <textarea name="comments" placeholder="Enter a message"></textarea>
                                                </div>
                                                <div className="comment-btn text-center">
                                                    <input type="submit" className="nir-btn" id="submit2" value="Send Message" />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
export default Contact;